import { useAuthStore } from '@/store/auth';

/** The panel is the Deenly team's; anyone else signed in belongs in the Academy (the study room). */
export default function team(to, from, next) {
    const authStore = useAuthStore();
    if (authStore.isAuthenticated && !authStore.isTeam) {
        return next('/akademija');
    }
    return next();
}
